import "./App.css";
import MainRoutes from "./Routes/MainRoutes";
import { ThemeModeProvider } from "./Utils/ThemeModeContext";


function App() {
  return (
    <ThemeModeProvider>
      <MainRoutes />
    </ThemeModeProvider>
  );
}

export default App;
